export default "__VITE_PUBLIC_ASSET__bfbe5487__"